export const slugify = (s?: string | null) => {
  if (s) {
    return s
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }
  return '';
};

export const unslugify = (slug?: string) => {
  if (slug) {
    const result = slug.replace(/\-/g, ' ');
    return result.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  return '';
};

function truncate(s: string, maxCharacters: number) {
  if (s.length <= maxCharacters) {
    return s;
  }
  const leftSide = Math.ceil(maxCharacters / 2);
  const rightSide = Math.floor(maxCharacters / 2);
  return s.substring(0, leftSide) + '_' + s.substring(s.length - rightSide);
}

export const filenameSafe = (s: string) =>
  truncate(decodeURIComponent(s), 200)
    .replace(/[^a-z0-9]/gi, '_')
    .toLowerCase();
